import React from "react";
import { Link as BaseLink } from "react-router-dom";

const Link = (props) => {
  return <BaseLink className="link" {...props} />;
};

export default Link;
